var module = angular.module('octopusApp.projects');

var defineSlickGrid = function(variableSettings, viewScope, octoDropdownMenu, rootScope, canEdit, showSourceColumn, octopusRepository, octoDialog, $q, disableContextMenu) {
  function requiredFieldValidator(value) {
    if (value == null || typeof value === 'undefined' || !value.length) {
      return {valid: false, msg: "This is a required field"};
    } else {
      return {valid: true, msg: null};
    }
  }

  var grid;
  var data = [];
  var dataView;
  var columns = [
    {id: "state", name: "<i class='variable-filter-icon'></i>", field: "state", width: 20, variableSettings: variableSettings, cssClass: "cell-nopadding", formatter: Slick.Formatters.OctopusVariableState, focusable: false, resizable: false, selectable: false },
    {id: "name", name: "Name", field: "name", width: 300, variableSettings: variableSettings,cssClass: "cell-title", editor: Slick.Editors.Text, validator: requiredFieldValidator, sortable: true},
    {id: "value", name: "Value", width: 500, variableSettings: variableSettings,editor: Slick.Editors.OctopusVariableValue, formatter: Slick.Formatters.OctopusVariableValue, sortable: true},
    {id: "scope", name: "Scope", field: "scope", width: 400, variableSettings: variableSettings, editor: Slick.Editors.OctopusVariableScope, formatter: Slick.Formatters.OctopusVariableScope, sortable: true}
  ];
  var resetSelectionOnFilter = true;
  
  if(showSourceColumn)
  {
    columns.push({id: "source", name: "Source", field: "source", width: 400, variableSettings: variableSettings, formatter: Slick.Formatters.OctopusVariableSource, sortable: true});
  }
  
  var options = {
    editable: canEdit,
    enableAddRow: canEdit,
    enableCellNavigation: true,
    asyncEditorLoading: false,
    autoEdit: canEdit,
    rowHeight: 28,
    explicitInitialization: true,
    enableColumnReorder: false,
    forceFitColumns: true,
    headerRowHeight: 30,
    showHeaderRow: true,
    autoHeight:true
  };

  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  function publicGrid() {
    return grid;
  }

  var init = function () {
    dataView = new Slick.Data.DataView();
    var columnFilters = { scope: { } };

    grid = new Slick.Grid("#myGrid", dataView, columns, options);

    grid.setSelectionModel(new Slick.CellSelectionModel());

    dataView.onRowCountChanged.subscribe(function (e, args) {
      grid.updateRowCount();
      grid.render();
    });

    var resetGridSelection = function() {
      grid.resetActiveCell();
      grid.setSelectedRows([]);
    };

    grid.onHeaderClick.subscribe(function(e, args) {
      if (args.column.id === "state") {
        if (grid.getOptions().showHeaderRow) {
          grid.setHeaderRowVisibility(false);
          columnFilters['scope'] = columnFilters['name'] = columnFilters['value'] = undefined;
          $('div.slick-headerrow-column input.editor-text').val('');
          $('button.variable-scope-editor.filter').text('Show all').removeClass('restricted');
          dataView.refresh();
        } else {
          resetGridSelection();
          grid.setHeaderRowVisibility(true);
        }
      }
    });

    var stringContains = function (recv, searchString) {
      return recv.toLowerCase().indexOf(searchString.toLowerCase()) >= 0;
    };

    var filter = function(gridRow) {
      if(resetSelectionOnFilter) {
        resetGridSelection();
      }

      for (var columnId in columnFilters) {
        /*jshint loopfunc: true */
        if (columnId !== undefined) {
          var filterVal = columnFilters[columnId];
          if (filterVal !== undefined) {

            var column = grid.getColumns()[grid.getColumnIndex(columnId)];
            if (columnId === "scope"){
              var missing =_.find(_.pairs(filterVal), function(nv) {
                var required = nv[1];
                if (!required || required.length === 0) {
                  return null;
                }
                var name = nv[0];
                var variableScope = gridRow[column.field];
                if (variableScope === undefined) {
                  return false;
                }
                var scopeValue = variableScope[name];
                  if (!scopeValue) {
                    //This is an unscoped variable, so we want to show it
                    return false;
                  }
                  return _.find(required, function(r){
                  return !_.find(scopeValue, function(s) { return r === s; });
                });
              });

              if (missing) {
                return false;
              }
            } else if (columnId === "value") {
              if (!stringContains(gridRow['value'] || '', filterVal)) {
                return false;
              }
            } else if (columnId === "source") {
              if (!stringContains(gridRow['source'].name || '', filterVal)) {
                return false;
              }
            } else {
              if (filterVal !== "") {
                if (!stringContains(gridRow[column.field] || '', filterVal)) {
                  return false;
                }
              }
            }
          }
        }
      }
      return true;
    };

    grid.onHeaderRowCellRendered.subscribe(function(e, args) {
      var columnId = args.column.id;
      if (columnId === "state") {
        return;
      }

      $(args.node).empty();

      if (columnId === 'scope'){
        var edd = new Slick.Editors.OctopusVariableScope({
          container: args.node,
          column: args.column,
          grid: grid,
          commitChanges: function() {
            var newScopeFilter = edd.serializeValue();
            columnFilters['scope'] = newScopeFilter;
            var filterToString = Slick.Helpers.OctopusVariableScopeToString(newScopeFilter, args.column.variableSettings);
            if (!filterToString) {
              $('button.variable-scope-editor.filter').text('Show all').removeClass('restricted');
            } else {
              $('button.variable-scope-editor.filter').text(filterToString).addClass('restricted');
            }
            dataView.refresh();
          },
          cancelChanges: function() {},
          isFilter: true
        });
        edd.loadValue({ scope: _.extend(columnFilters['scope']) });
      } else {
        $("<input class='editor-text' type='text' placeholder='Show all'>")
          .val(columnFilters[columnId])
          .on('keyup', function() {
            columnFilters[columnId] = $.trim($(this).val());
            dataView.refresh();
          })
          .on('change', function() {
            columnFilters[columnId] = $.trim($(this).val());
            dataView.refresh();
          })
          .appendTo(args.node);
      }
    });

    var scopeGreater = function(field, a, b) {
      var va = a[field] || [];
      var vb = b[field] || [];

      if (va.length === 0 && vb.length === 0) {
        return 0;
      }

      if (va.length === 0) {
        return 1;
      }

      if (vb.length === 0) {
        return -1;
      }

      if (va.length !== vb.length) {
        // No/less scope is broader ('greater') than any scope/more
        return va.length > vb.length ? 1 : -1;
      }

      var ca = va.slice(0).sort();
      var sa = _.reduce(ca, function(m, s) { return m + s + '; '; }, '');
      var cb = vb.slice(0).sort();
      var sb = _.reduce(cb, function(m, s) { return m + s + '; '; }, '');
      if (sa === sb) {
        return 0;
      }
      return (sa > sb) ? 1 : -1;
    };

    grid.onSort.subscribe(function(e, args) {

      var comparer = function(a, b) {
        var sortA = a[args.sortCol.id];
        var sortB = b[args.sortCol.id];

        if (args.sortCol.id === 'scope') {
          var scopeSort = 0;
          scopeSort = scopeGreater('steps', sortA, sortB);
          if (scopeSort !== 0) {
            return scopeSort;
          }
          scopeSort = scopeGreater('machines', sortA, sortB);
          if (scopeSort !== 0) {
            return scopeSort;
          }
          scopeSort = scopeGreater('roles', sortA, sortB);
          if (scopeSort !== 0) {
            return scopeSort;
          }
          scopeSort = scopeGreater('environments', sortA, sortB);
          return scopeSort;
        }

        if(sortA && sortA.name)
        {
          return (sortA.name > sortB.name) ? 1 : -1;
        }

        return (sortA > sortB) ? 1 : -1;
      };

      dataView.sort(comparer, args.sortAsc);
    });

    dataView.onRowsChanged.subscribe(function (e, args) {
      grid.invalidateRows(args.rows);
      grid.render();
    });

    var getRowMetadata = function(original) {
      return function(row) {
        var item = this.getItem(row),
          ret = original(row);

        if (item && item.state === "Deleted") {
          ret = ret || {};
          ret.cssClasses = (ret.cssClasses || '') + ' deleted';
        }

        return ret;
      };
    };

    dataView.getItemMetadata = getRowMetadata(dataView.getItemMetadata);

    dataView.beginUpdate();
    dataView.endUpdate();

    grid.setSelectionModel(new Slick.CellSelectionModel());

    grid.onBeforeEditCell.subscribe(function(e,args) {
      if (typeof args.item === "undefined") {
        if (args.column.id !== "name") {
          return false;
        }
        return true;
      }
      return args.item.isEditable;
    });

    grid.onAddNewRow.subscribe(function (e, args) {
      var item = args.item;

      item.isEditable = true;

      if (item.name) {
        item.value = "";
        item.scope = {};
      } else if (item.value) {
        item.name = "";
        item.scope = {};
      } else if (item.scope) {
        item.name = "";
        item.value = "";
      }

      if (item.name || item.value || item.scope) {
        item["state"] = "New";
        item.id = guid();
        item.reset = function() {
          dataView.deleteItem(item.id);
          checkDirty();
        };
        resetSelectionOnFilter = false;
        dataView.addItem(item);
        resetSelectionOnFilter = true;
      }
      checkDirty();
    });

    grid.onCellChange.subscribe(function (e, args) {
      var selected = args.grid.getSelectedRows();
      if (selected && selected.length > 1) {
        var column = grid.getColumns()[args.cell];

        var sourceItem = dataView.getItem(args.row);

        dataView.beginUpdate();

        var copyScope = function(source) {
          var result = {};
          _.each(source, function (val, key) {
            result[key] = [];
            _.each(val, function (v) {
              result[key].push(v);
            });
          });
          return result;
        };

        for (var i = selected[0]; i <= selected.slice(-1)[0]; i++) {
          if (i === args.row) {
            continue;
          }
          var item = dataView.getItem(i);
          if (column.id === "name") {
            item.name = sourceItem.name;
          } else if (column.id === "value") {
            item.value = sourceItem.value;
            item.isSensitive = sourceItem.isSensitive;
          } else if (column.id === "scope") {
            item.scope = copyScope(sourceItem.scope);
          }

          if (item.state === "") {
            item.state = "Changed";
          }
          grid.invalidateRow(i);
        }

        dataView.endUpdate();
        grid.render();
      }
      if (args.item.state === "") {
        args.item.state = "Changed";
      }
      args.grid.updateCell(args.row, 0);

      checkDirty();
    });

    grid.onContextMenu.subscribe(function (e) {
      e.preventDefault();
      if (disableContextMenu) { return; }

      var cell = grid.getCellFromEvent(e);

      grid.setActiveCell(cell.row, cell.cell);

      var node = grid.getCellNode(cell.row, cell.cell);

      var variable = dataView.getItem(cell.row);

      octoDropdownMenu.show(viewScope, $(node), 'variableDropdown', { variable: variable, row: cell.row, hasChanges: variable.state !== "" }, { x: e.pageX, y: e.pageY });
    });

    grid.onValidationError.subscribe(function (e, args) {
    });

    grid.init();
    dataView.setFilter(filter);
    grid.setHeaderRowVisibility(false);

    $(window).resize(function() {
      grid.resizeCanvas();
    });
    $(window).focus(function() {
      setTimeout(function() {
        grid.resizeCanvas();
      }, 100);
    });
    setTimeout(function() {
      grid.resizeCanvas();
    }, 100);
    setTimeout(function() {
      grid.resizeCanvas();
    }, 1000);
  };

  var checkDirty = function() {
    var dirty = false;
    var items = dataView.getItems();

    for (var i = 0; i < items.length; i++) {
      if (items[i].state !== "") {
        dirty = true;
        break;
      }
    }

    var raise = function() {
      if (dirty) {
        viewScope.$emit("variableEditor:dirty");
      } else  {
        viewScope.$emit("variableEditor:clean");
      }
    };

    if(!viewScope.$$phase && !rootScope.$$phase) {
      viewScope.$apply(raise);
    } else {
      raise();
    }
  };

  var dataViewHasVariable = function(variable) {
    var hasVariable = _.some(dataView.getItems(), function(item) { return item.id === variable.Id; });
    return hasVariable;
  };

  var updateVariableResourceFromDataViewItem = function(resource, item) {
    resource["Id"] = item.id;
    resource["Name"] = item.name;
    resource["Value"] = item.value !== null ? item.value.trim() : null;
    resource["IsSensitive"] = item.isSensitive;
    if (item.prompt) {
      resource["Prompt"] = {
        "Label": item.prompt.label,
        "Description": item.prompt.description,
        "Required": item.prompt.required
      };
    } else {
      resource["Prompt"] = null;
    }
    if (item.scope) {
      resource["Scope"] = {
        "Environment": item.scope.environments,
        "Machine": item.scope.machines,
        "Action": item.scope.steps,
        "Role": item.scope.roles,
        "Channel": item.scope.channels,
        "TenantTag": item.scope.tenantTags,
        "Tenants": item.scope.tenants
      };
    }
  };

  var refreshAndCheckDirty = function() {
    dataView.refresh();
    grid.invalidateAllRows();
    grid.render();
    checkDirty();
  };

  return {
    init: init,

    publicGrid: publicGrid,

    update: function(variableSet) {
      if (!variableSet || !variableSet.Variables) {
        return;
      }

      var mapVariable = function(v) {
        var d = {};

        d.reset = function() {
          d["id"] = v.Id;
          d["state"] = v.State || "";
          d["name"] = v.Name;
          d["value"] = v.Value;
          d["isSensitive"] = v.IsSensitive;
          d["isEditable"] = v.IsEditable;
          d["prompt"] = null;
          if (v.Prompt) {
            d["prompt"] = { };
            d["prompt"]["label"] = v.Prompt.Label;
            d["prompt"]["description"] = v.Prompt.Description;
            d["prompt"]["required"] = v.Prompt.Required;
          }
          d["scope"] = {};
          if (v.Scope) {
            d["scope"]["environments"] = v.Scope["Environment"];
            d["scope"]["machines"] = v.Scope["Machine"];
            d["scope"]["steps"] = v.Scope["Action"];
            d["scope"]["roles"] = v.Scope["Role"];
            d["scope"]["channels"] = v.Scope["Channel"];
            d["scope"]["tenantTags"] = v.Scope["TenantTag"];
            d["scope"]["tenants"] = v.Scope["Tenant"];
          }
          d["source"] = v.Source;
        };

        d.reset();
        return d;
      };

      var data = _.chain(variableSet.Variables).sortBy(function(v) {
        return v.Name.toLowerCase() + " " + v.Id;
      }).map(mapVariable).value();

      dataView.beginUpdate();
      dataView.setItems(data);
      dataView.endUpdate();

      refreshAndCheckDirty();
    },

    notifyChanged: function() {
      refreshAndCheckDirty();
    },

    destroy: function() {
      grid.destroy();
    },

    markForDeletion: function(variable) {
      var selected = grid.getSelectedRows();

      var toDeleteImmediately = [];

      if (!selected || selected.length === 0) {
        if (grid.getActiveCell() != null) {
          selected = [grid.getActiveCell().row];
        }
      }

      for (var i = selected[0]; i <= selected.slice(-1)[0]; i++) {
        var item = dataView.getItem(i);

        if (item.state === "New") {
          toDeleteImmediately.push(item.id);
        } else {
          item.state = "Deleted";
        }
      }

      for (var k = 0; k < toDeleteImmediately.length; k++) {
        dataView.deleteItem(toDeleteImmediately[k]);
      }

      refreshAndCheckDirty();
    },

    duplicate: function(variable, row) {
      var copy = {};
      copy.id = guid();
      copy.name = variable.name;
      if (!variable.isSensitive) {
        copy.value = variable.value;
      } else {
        copy.value = "";
      }
      copy.scope = variable.scope;
      copy.state = "New";
      copy.reset = function() {
        dataView.deleteItem(copy.id);
        refreshAndCheckDirty();
      };
      dataView.insertItem(row, copy);
      refreshAndCheckDirty();
    },

    confirmNonPrintableChars: function(success) {
      var warnings = [];
      var promises = []; 

      var displayNonPrintableChar = function(str, i) {
        return "(Position: " + i + ", Unicode value: U+" + ("0000" + str.charCodeAt(i).toString(16)).slice(-4) + ")";
      };

      var checkForNonPrintableChars = function(variableName, str, msgPrefix) {
        return octopusRepository.Variables.nonPrintableChars(str)
          .then(function(nonPrintableCharIndexes){
            if (!_.isEmpty(nonPrintableCharIndexes)){
             warnings.push(
                nonPrintableCharIndexes.length > 1 
                  ? msgPrefix + " variable '" + variableName + "' contains characters which may not be visible:<br/>" 
                    + _.map(nonPrintableCharIndexes, function(x){ return displayNonPrintableChar(str, x);}).join("<br/>")
                  : msgPrefix + " variable '" + variableName + "' contains characters which may not be visible:<br/>" 
                    + displayNonPrintableChar(str, nonPrintableCharIndexes[0])
             );
            }
          });
      };

      for (var j = 0; j < dataView.getLength(); j++) {
        var item = dataView.getItem(j);

        if (item.state !== "New" && item.state !== "Changed") {
          continue;
        }

        promises.push(checkForNonPrintableChars(item.name, item.name, "Name of"));
        promises.push(checkForNonPrintableChars(item.name, item.value, "Value of"));
      }

      $q.all(promises).then(function(){ 
        if (_.isEmpty(warnings)){
          success();
          return;
        }

        octoDialog.asyncConfirm({
         title: "Non-printable characters",
         message: _.reduce(warnings, function(memo, line) { return "<p>" + line + "</p>";}, ""),
         executeButtonClass: "btn-warning",
         executeButtonText: "Save anyway",
         execute: function(dialog){ 
          dialog.dismiss();
          success(); 
          }
        } );
      });
    },

    applyChanges: function(variableSet) {
      var variablesById = {};
      for (var i = 0; i < variableSet.Variables.length; i++) {
        var v = variableSet.Variables[i];
        variablesById[v.Id] = v;

        var hasVariable = dataViewHasVariable(v);
        if (hasVariable) {
          variablesById[v.Id] = v;
        }
        else {
          variableSet.Variables.splice(i, 1); // Remove variable that was deleted from the dataView immediately but still in the parent variableSet
        }
      }

      var dataViewItems = dataView.getItems();
      var dataViewItemCount = 0; // Using dataView.getItems.length because dataView.getLength is affected by filtering
      if (dataViewItems) {
        dataViewItemCount = dataViewItems.length;
      }

      for (var j = 0; j < dataViewItemCount; j++) {
        var item = dataViewItems[j];
        if (item.state === "") {
          continue; // no changes
        }

        if (item.state === "Deleted") {
          var index = variableSet.Variables.indexOf(variablesById[item.id]);
          if(index >= 0) { // If saving failed once (due to network error) and user saves again the variable won't be found and we'll get -1 here
            variableSet.Variables.splice(index, 1);
          }
          continue;
        }

        var resource = variablesById[item.id];
        if (!resource) {
          resource = {};
        }
        updateVariableResourceFromDataViewItem(resource, item);

        if (item.state === "New" && !variablesById[resource.Id]) {
          variableSet.Variables.push(resource);
        }
      }

      return true;
    }
  };
};

module.directive('variableEditor', function(octoDropdownMenu, $rootScope, $timeout, octopusRepository, octoDialog, $q, $uibModal) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      data: '=',
      tab: '='
    },
    templateUrl: 'areas/projects/views/variables_editor.html',
    link: function(scope, element) {

      var settings = {};

      var editor = $("#myGrid", element);
      editor.css("height", "auto");
      editor.css("margin-bottom", "5px");

      var grid = null;

      scope.showScopePicker = function(selectedScopeValues, isFilter, callback) {
        $uibModal.open({
          backdrop: true,
          keyboard: true,
          templateUrl: 'areas/projects/views/variables_editor_scope.html',
          controller: 'VariableEditorScopeController',
          controllerAs: 'vm',
          bindToController: true,
          resolve: {
            selectedScopeValues: function(){
              return selectedScopeValues;
            },
            availableScopeValues: function(){
              return scope.data.variableSet.ScopeValues;
            },
            isFilter: function(){
              return isFilter;
            },
            canScopeToTenantTags: function () {
              return scope.data.canScopeToTenantTags;
            }
          }
        }).result.then(function (result) {
          if (!result) {
            callback();
          } else {
            callback(result.selectedScopeValues);
          }
        });
      };

      scope.$watch("data", function(v) {
        if (scope.data != null) {
          settings.scopeOptions = scope.data.scopeOptions;

          $timeout(function() {
            grid = defineSlickGrid(settings, scope, octoDropdownMenu, $rootScope, scope.data.canEdit, scope.data.showSourceColumn,
              octopusRepository, octoDialog, $q, !!scope.data.disableContextMenu);
            grid.init();
            grid.update(scope.data.variableSet);
          }, 200);
        }
      });

      // Resize on tab changes (helps avoid weird timing issues in Angular).
      scope.$watch("tab", function(v) {
        if (grid && grid.publicGrid() && scope.tab != null) {
          setTimeout(function() {
            grid.publicGrid().resizeCanvas();
          }, 100);
        }
      });

      scope.$on("destroy", function() {
        if (grid) {
          grid.destroy();
        }
      });

      scope.duplicateVariable = function(variable, row) {
        grid.duplicate(variable, row);
        grid.notifyChanged();
      };

      scope.deleteVariable = function(variable) {
        grid.markForDeletion(variable);
        grid.notifyChanged();
      };

      scope.resetChanges = function(variable) {
        variable.reset();
        grid.notifyChanged();
      };

      element.keyup(function(e) {
        if (e.keyCode === 46) {
          e.preventDefault();

          grid.markForDeletion(null);

          return false;
        }
      });

      scope.$on("variableEditor:applyChanges", function(e, vs) {
        grid.confirmNonPrintableChars(function(){
          var valid = grid.applyChanges(vs);
          if (valid) {
            scope.$emit("variableEditor:changesApplied", vs);
          }
        });
      });

    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/variable_editor.js
// module id = 554
// module chunks = 1